import z from 'zod';

export type FlavourDto = z.infer<typeof flavourDtoSchema>;
export const flavourDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
});

export type TasteVideoDto = z.infer<typeof tasteVideoDtoSchema>;
export const tasteVideoDtoSchema = z.object({
  image: z.string().nullable().optional(),
  url: z.string(),
});

export type ProductDto = z.infer<typeof productDtoSchema>;
export const productDtoSchema = z.object({
  id: z.string(),
  title: z.string(),
  image: z.string().nullable().optional(),
  url: z.string(),
  prominent_flavors: z.array(flavourDtoSchema),
  tastewheel_video_landscape: tasteVideoDtoSchema.nullable(),
  tastewheel_video_portrait: tasteVideoDtoSchema.nullable(),
  taste_graph: z.object({
    flavour: z.array(z.string()),
    mouthfeel: z.array(z.string()),
    outer_flavour: z.array(z.string()),
    taste: z.array(z.string()),
    taste_dimension: z.array(z.string()),
  }),
});
